import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {faBolt} from '@fortawesome/free-solid-svg-icons';
import {LocalStorageService} from '../../local-storage.service';
import {CaptureImageData} from '../models/captureImage-model';
import {Orders} from '../models/order-model';
import {CaptureImageService} from '../services/capture-image.service';
import {SharedDataService} from '../services/shared-data.service';
import {ToaterMessagesService} from '../services/toaster-messages.service';
import {MessageBoxService} from '../../services/message-box.service';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from '../services/data.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {BehaviorSubject, tap} from 'rxjs';
import {HelperService} from '../../services/helper.service';
import {SwissSettingsService} from '../../services/swiss-settings.service';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements OnInit {
    protected faBolt = faBolt;
    public currentLang!: string;
    public auftrag!: Orders;
    protected view = 'OrderView';
    protected orderImages: BehaviorSubject<CaptureImageData[]> = new BehaviorSubject([] as CaptureImageData[]);
    protected dayImages: BehaviorSubject<CaptureImageData[]> = new BehaviorSubject([] as CaptureImageData[]);
    protected debugMode: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private router: Router,
        private localStorage: LocalStorageService,
        public dialog: MatDialog,
        public captureImageService: CaptureImageService,
        private shareDataService: SharedDataService,
        private route: ActivatedRoute,
        private toasterMessagesService: ToaterMessagesService,
        private messageBoxService: MessageBoxService,
        private translate: TranslateService,
        private dataService: DataService,
        private settingsService: SwissSettingsService
    ) {

        this.route.params.pipe(
            takeUntilDestroyed()).subscribe(async (params) => {
            const orderID = params.orderID;
            if (orderID) {
                const orders = await this.localStorage.get('orders', 'SwissTimeEntry', true, []);
                this.auftrag = orders.find((el: any) => el.objectID === orderID);
            }
            await this.loadImageLists();
        });
        this.settingsService.getWebConfig$().pipe(
            takeUntilDestroyed(),
            tap(config => {
                this.debugMode.next(config.debugMode);
            })
        ).subscribe();
    }

    ngOnInit(): void {
        this.localStorage.get('language', 'SwissTimeEntry', true).then((res: any) => {
            this.currentLang = res;
        });
    }

    /* TOD0 2025-10-08 EN-4006/4229 - Disabled due to ios bug Images are sent weirdly once description has been changed
    async editDescription(img: CaptureImageData): Promise<void> {
        const dialogRef = this.dialog.open(EditImageDetailsComponent, {
            height: 'auto',
            data: img,
        });

        dialogRef
            .afterClosed()
            .pipe(first())
            .subscribe({
                next: async (resultImg: any) => {
                    if (!resultImg) {
                        return;
                    }
                    await this.captureImageService.editDescription(img, resultImg);
                    await this.loadImageLists();
                },
            });
    }
    */

    public async openCamera(event: any): Promise<void> {
        if (!this.auftrag) {
            this.translate.get('MAIN_APP_DIALOG.ERROR_DIALOG.TIME_APP_ERROR.ORDER_NOT_FOUND.text').subscribe((t: string) => {
                this.messageBoxService.showError(t, '');
            });
            return;
        }
        await this.captureImageService.capturedImage(event, this.auftrag);
        await this.loadImageLists();
    }

    async openDeleteDialog(img: any): Promise<void> {
        const result = await this.messageBoxService.askYesNoQuestion('MAIN_APP_DIALOG.DEL_IMG.msg', 'MAIN_APP_DIALOG.DEL_IMG.title', [img.fileName]);
        if (!result) {
            return;
        }
        if (await this.captureImageService.deleteImage(img)) {
            this.toasterMessagesService.toasterTranslateSuccessMessages('Bild erfolgreich gelöscht', 'Image supprimée avec succès', this.currentLang);
            await this.loadImageLists();

        } else {
            this.toasterMessagesService.toasterTranslateErrorMessages('Bild nicht gelöscht', 'Image supprimée avec error', this.currentLang);
        }
    }

    public switchView(): void {
        this.view = this.view === 'OrderView' ? 'DayView' : 'OrderView';
    }


    protected editImg(img: CaptureImageData): void {
        this.shareDataService.shareImage(img);
        this.router.navigate(['timeapp/edit-img']);
    }

    protected async desyncImage(item: CaptureImageData): Promise<void> {
        if (!this.debugMode.getValue()) {
            return;
        }
        const desyncImage = await this.messageBoxService.askYesNoQuestion('Soll das Bild desynchronisiert werden?', 'Desync?');
        if (desyncImage) {
            const images = await this.captureImageService.getImages();
            const i = images.findIndex(img => img.objectID === item.objectID && img.fileName === item.fileName && img.description === item.description);
            if (i < 0) {
                this.messageBoxService.showError('Bild wurde nicht gefunden', '!!Fehler!!');
                return;
            }
            images[i].synced = false;
            images[i].uploadDate = new Date().toDateString();
            await this.captureImageService.setImageData(images);
            await this.loadImageLists();
        }
    }

    protected async downloadImage(item: CaptureImageData): Promise<void> {
        return HelperService.downLoadFile(item.blob, item.fileName);
    }

    private async loadImageLists(): Promise<void> {
        const images = await this.captureImageService.getImages();
        this.orderImages.next(images.filter(e => e.objectID === this.auftrag.objectID));
        const chosenDay = this.dataService.getChosenDate();
        this.dayImages.next(images.filter(e => e.uploadDate === chosenDay.toDateString()));
    }
}
